/*************************************************************************
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { getPageZoomLevel } from "../selectors/commonAppSelectors";

export const isTouchSelectionInProgress = stores =>
  stores.touchSelStore.isTouchSelectionInProgress;

export const isTouchSelectionPresent = stores =>
  stores.touchSelStore.isTouchSelectionInProgress ||
  stores.touchSelStore.showGrabbers;

export const showGrabbers = (stores, index) =>
  stores.touchSelStore.showGrabbers &&
  stores.touchSelStore.touchSelPageIndex === index;

export const getSelLeftX = stores => stores.touchSelStore.selLeftX;

export const getSelLeftY = stores => stores.touchSelStore.selLeftY;

export const getSelRightX = stores => stores.touchSelStore.selRightX;

export const getSelRightY = stores => stores.touchSelStore.selRightY;

export const getTouchSelPageIndex = stores => {
  if (stores.touchSelStore.touchSelPageIndex)
    return stores.touchSelStore.touchSelPageIndex;
  return 0;
};

export const getShouldHideContextMenu = stores =>
  stores.touchSelStore.shouldHideContextMenu;

export const getEventOnGrabber = stores => stores.touchSelStore.eventOnGrabber;

export const getShouldEnableContextMenuOnTouchDevices = stores =>
  stores.touchSelStore.enableContextMenuOnTouchDevices;

export const isTouchEvent = stores => stores.touchSelStore.touchEvent;

export const getTextSelectionPageRange = stores =>
  stores.touchSelStore.textSelectionPageRange;

export const getTextInSelection = stores =>
  stores.touchSelStore.textInSelection;

export const isThereAnySelection = stores =>
  stores.touchSelStore.isThereAnySelection;

export const getTextOrientation = stores =>
  stores.touchSelStore.textOrientation;

export const getRightGrabberLeft = (stores, index) =>
  stores.touchSelStore.rightGrabberLeft * getPageZoomLevel(stores, index);

export const getRightGrabberTop = (stores, index) =>
  stores.touchSelStore.rightGrabberTop * getPageZoomLevel(stores, index);

export const getLeftGrabberBottom = (stores, index) =>
  stores.touchSelStore.leftGrabberBottom * getPageZoomLevel(stores, index);

export const getLeftGrabberRight = (stores, index) =>
  stores.touchSelStore.leftGrabberRight * getPageZoomLevel(stores, index);

export const getRichTextInSelection = stores =>
  stores.touchSelStore.richTextInSelection;
